export const cusData = {
    'USERINFO': 'fm_userInfo',
    'companyId': 'fm_companyId'
}